import { render, staticRenderFns } from "./PageGuide.vue?vue&type=template&id=d5b9df98"
import script from "./PageGuide.vue?vue&type=script&lang=js"
export * from "./PageGuide.vue?vue&type=script&lang=js"
import style0 from "./PageGuide.vue?vue&type=style&index=0&id=d5b9df98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports